// extracted by mini-css-extract-plugin
module.exports = {"root":"_0c52f2","nameContainer":"_976cbc","featureName":"_662fea","noBottomPadding":"_b57994"};